var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 22.5C9 23.6 9.9 24.5 11 24.5H19C20.1 24.5 21 23.6 21 22.5V12.5C21 11.4 20.1 10.5 19 10.5H11C9.9 10.5 9 11.4 9 12.5V22.5ZM21 7.5H18.5L17.79 6.79C17.61 6.61 17.35 6.5 17.09 6.5H12.91C12.65 6.5 12.39 6.61 12.21 6.79L11.5 7.5H9C8.45 7.5 8 7.95 8 8.5C8 9.05 8.45 9.5 9 9.5H21C21.55 9.5 22 9.05 22 8.5C22 7.95 21.55 7.5 21 7.5Z",
    fill: "#ADB8CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDark);
export default __webpack_public_path__ + "static/media/delete_dark.9fed6bc11a2821e65f1f856cebb518f2.svg";
export { ForwardRef as ReactComponent };